import { createIcon } from '../createIcon';
import { ReactComponent as IconEyeInvisible } from '../svg/eye-invisible.svg';

export default createIcon(IconEyeInvisible);
